module.exports = "/_next/static/images/phone-api-fcc8225e35a1e7bf90e74ae9abd34da9.jpg";